<script setup>
const emit = defineEmits(["closeModal"]);
defineProps({
  title: {
    type: String,
    default: ""
  }
});
</script>

<template>
  <div class="project-header">
    <span class="project-header__title">
      {{ title }}
    </span>

    <button
      class="project-header__close"
      @click="emit('closeModal')"
    >
      <IconCross />
    </button>
  </div>
</template>

<style scoped lang="scss">

.project-header {
  display: flex;
  justify-content: space-between;

  &__title {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    color: var(--text-text-black);
  }

  &__close {
    cursor: pointer;
    color: var(--icon-icon-secondary);
    background-color: transparent;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      color: var(--icon-icon-on);
    }
  }
}
</style>
